import { StyleFunctionProps } from "@chakra-ui/theme-tools"
import { rgba } from "polished"


export function getHoverColor(props: StyleFunctionProps) {
  const { theme } = props
  const hoverColor = rgba(theme.colors.scene.primary.normal, 0.06)

  return hoverColor
}
